import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { BoxTransfersRequestType, IBoxTransferUser } from '../interfaces';
import { BoxTransferMapper } from '../mappers';
import { boxTransfersEndpointMap } from '../utils';

export type IGetBoxTransfersRepoResponse = IRepoResponse<200, { data: IBoxTransferUser[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetBoxTransfersRepo = IRepo<[Record<string, any>, BoxTransfersRequestType], IGetBoxTransfersRepoResponse>;

export const GetBoxTransfersRepoType = Symbol.for('GetBoxTransfersRepo');

@bind(GetBoxTransfersRepoType)
export class GetBoxTransfersRepo implements IGetBoxTransfersRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: Record<string, any> = {}, type: BoxTransfersRequestType = BoxTransfersRequestType.BRANCH) {
    try {
      const pathname = boxTransfersEndpointMap[type];
      const url = urlMaker(pathname, query);
      const result = await this.httpClient.get({ url });

      if (result.status === 200) {
        const data: IBoxTransferUser[] = result.data.data.map(BoxTransferMapper.toDomain);
        const total: number = result.data.meta?.total || 0;

        return {
          status: 200 as 200,
          response: { data, total },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
